import React, { Component } from 'react'

import { withRouter } from 'react-router'

import axios from 'axios'

import { catchToastNotification } from '../../../api'
import { compose } from 'redux'
import InfoComponent from './InfoComponent'
import { withController } from '../../../api/controllerContext'
import { Link } from 'react-router-dom'

class Footer extends Component {
  state = {
    versionData: '',
    versionStatus: 0,
    corpusData: {},
    corpusStatus: 0,
  }

  componentDidMount() {
    this.getVersionData()
  }

  //@TODO: add this to swagger!
  getVersionData = () => {
    axios({
      method: 'get',
      url: `${window.REACT_APP_API_URL}/version`,
      headers: {
        Accept: 'application/json',
      },
    })
      .then((version) => {
        this.setState({ versionData: version.data })
        this.setState({ versionStatus: version.status })
      })
      .catch(catchToastNotification)
  }

  render() {
    const currentYear = new Date().getFullYear()
    return (
      <>
        <footer
          className="container-fluid pt-2 border-top shadow-sm bg-light"
          style={{ fontSize: '11px' }}
        >
          <div className="row">
            <div className="col-12 col-sm-8 offset-md-4 col-md-4 text-center">
              <span className="h6">About</span>
              <br />
              <span className="text-small text-muted">
                <Link className="text-muted pr-2" to="/support">
                  Support
                </Link>
                |
                <a
                  className="text-muted  pl-2 pr-2"
                  href="https://www.scaiview.com/en/contact.html"
                >
                  Contact
                </a>
                |
                <a
                  className="text-muted pl-2 pr-2"
                  href="https://www.scaiview.com/en/publishing-notes.html"
                >
                  Imprint
                </a>
                |
                <a
                  className="text-muted  pl-2 pr-2"
                  href="https://www.scaiview.com/en/terms-and-conditions.html"
                >
                  Terms and Conditions
                </a>
                |
                <a
                  className="text-muted  pl-2"
                  href="https://www.scaiview.com/en/data_protection.html"
                >
                  Data Protection Information
                </a>
              </span>{' '}
              <br />
              <InfoComponent
                versionData={this.state.versionData}
                versionStatus={this.state.versionStatus}
                corpusData={this.state.corpusData}
                corpusStatus={this.state.corpusStatus}
              />
            </div>
            <div
              className="col-12 col-sm-4 col-md-4 text-right"
              style={{ paddingTop: '10px' }}
            >
              <a href="https://www.scai.fraunhofer.de">
                <img
                  className="mb-2"
                  src={`${process.env.PUBLIC_URL}/static/brand/fraunhofer-logo.gif`}
                  alt=""
                  width="120"
                />
                <small className="d-block mb-3 text-muted">
                  &copy; {currentYear} Fraunhofer-Gesellschaft
                </small>
              </a>
            </div>
          </div>
        </footer>
      </>
    )
  }
}

export default compose(withController, withRouter)(Footer)
